import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IInvoiceAddress } from '../interfaces/invoice-address';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { IInvoiceAddressFilter } from '../interfaces/invoice-address-filter';
import { IInvoiceAddressHistory } from '../interfaces/invoice-address-history';

@Injectable({ providedIn: 'root' })
export class InvoiceAddressService extends EditService<IInvoiceAddress, IInvoiceAddressFilter> {
  url = '/api/invoiceaddress';
  entityTitle = 'Invoice Address';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
  save(invoiceAddress: IInvoiceAddress): Promise<any> {
    let successMsg = invoiceAddress.id == 0 ? 'Invoice address added.' : 'Invoice address updated.';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json;charset=utf-8' });
    return this.handleRequest(
      this.http.post(this.url + '/save', invoiceAddress, { headers: headers }),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
  // getForAllOrganisationDepartmentsPage(organisationId: number): Promise<IPageResult<IInvoiceAddress>> {
  //     return this.handleRequest(this.http.get<IPageResult<IInvoiceAddress>>(this.url+'/getForAllDepartmentsByOrganisation/'+ organisationId), this.handlersFactory.getForReadAll())
  // }

  getForAllOrganisationDepartments(organisationId: number): Promise<IInvoiceAddress[]> {
    return this.handleRequest(
      this.http.get<IInvoiceAddress[]>(this.url + '/departments/' + organisationId),
      this.handlersFactory.getForReadAll(),
    );
  }

  getForDepartment(customerDepartmentId: number): Promise<IInvoiceAddress> {
    return this.handleRequest(
      this.http.get(this.url + '/department/' + customerDepartmentId),
      this.handlersFactory.getForReadAll(),
    );
  }

  getForOrganisation(organisationId: number): Promise<IInvoiceAddress> {
    return this.handleRequest(
      this.http.get<IInvoiceAddress>(this.url + '/organisation/' + organisationId),
      this.handlersFactory.getForReadAll(),
    );
  }
  approve(invoiceAddressId: number): Promise<any> {
    let successMsg = 'Invoice Address Approved';
    return this.handleRequest(
      this.http.post(`${this.url}/approve/${invoiceAddressId}`, null),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
  unapprove(invoiceAddressId: number): Promise<any> {
    let successMsg = 'Invoice Address Disapproved';
    return this.handleRequest(
      this.http.post(`${this.url}/unapprove/${invoiceAddressId}`, null),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
  getHistory(invoiceAddressId: number): Promise<IInvoiceAddressHistory[]> {
    return this.handleRequest(
      this.http.get<IInvoiceAddressHistory[]>(this.url + '/history/' + invoiceAddressId),
      this.handlersFactory.getForReadAll(),
    );
  }

  validateInvoiceAddress(invoiceAddress: IInvoiceAddress) {
    if (
      !invoiceAddress ||
      !invoiceAddress.invoiceCompanyName ||
      !invoiceAddress.invoiceContactFirstName ||
      !invoiceAddress.invoiceContactLastName ||
      !invoiceAddress.addressLine1 ||
      !invoiceAddress.postCode ||
      !invoiceAddress.town ||
      !invoiceAddress.invoiceContactEmail
    )
      return false;
    return true;
  }
}
